import React, {useEffect, useMemo, useState} from 'react';
import {View, StyleSheet} from 'react-native';
import Text from '@/components/basic/text';
import {errorLog, toPriceStr} from '@/utils';
import {UserListItem} from '../invitation.type';
import globalStore from '@/services/global.state';
import {defaultTableData} from '../invitation.variables';
import {useTranslation} from 'react-i18next';

const BORDER_COLOR = '#d0bd88';
const BG_COLOR = '#5d1b3f';

const InvitationRuleTable = () => {
  const [userList, setUserList] = useState<UserListItem[]>();
  const {t} = useTranslation();
  useEffect(() => {
    globalStore.asyncGetItem('invitationBonusList').then(user => {
      try {
        user && setUserList(JSON.parse(user) as UserListItem[]);
      } catch (e) {
        errorLog('error', e);
      }
    });
  }, []);

  const tableData = useMemo(() => {
    if (!userList || !userList.length) {
      return defaultTableData.map(([invite, deposit, bonus]) => [
        `${invite} ${t('invitation.rule.table.people')}`,
        toPriceStr(deposit, {fixed: 0, thousands: true}),
        toPriceStr(bonus, {fixed: 0, thousands: true}),
      ]);
    }
    return userList.map(item => [
      `${item.inviteNumber} ${t('invitation.rule.table.people')}`,
      toPriceStr(item.depositAmount, {fixed: 0, thousands: true}),
      toPriceStr(item.bonusAmount, {fixed: 0, thousands: true}),
    ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userList]);

  return (
    <View style={styles.tableWrap}>
      {/* 表头 */}
      <View style={styles.headerRow}>
        <View style={[styles.cell, styles.leftCell, styles.borderRight]}>
          <Text style={styles.headerText}>
            {t('invitation.rule.table.invitationCount')}
          </Text>
        </View>
        <View style={[styles.cell, styles.rightCell]}>
          <Text style={styles.headerText}>
            {t('invitation.rule.table.rewards')}
          </Text>
        </View>
      </View>
      {/* 内容 */}
      {tableData.map((row, idx) => (
        <View
          key={idx}
          style={[
            styles.dataRow,
            idx !== tableData.length - 1 && styles.rowBorder,
          ]}>
          <View style={[styles.cell, styles.leftCell, styles.borderRight]}>
            <Text style={styles.dataText}>{row[0]}</Text>
          </View>
          <View style={[styles.cell, styles.rightCell]}>
            <Text style={styles.dataText}>{row[2]}</Text>
          </View>
        </View>
      ))}
    </View>
  );
};

const styles = StyleSheet.create({
  tableWrap: {
    borderRadius: 10,
    overflow: 'hidden',
    marginBottom: 16,
    backgroundColor: BG_COLOR,
    borderWidth: 1,
    borderColor: BORDER_COLOR,
  },
  headerRow: {
    flexDirection: 'row',
    backgroundColor: BG_COLOR,
    borderBottomWidth: 1,
    borderBottomColor: BORDER_COLOR,
  },
  dataRow: {
    flexDirection: 'row',
    minHeight: 40,
    alignItems: 'center',
    backgroundColor: BG_COLOR,
  },
  rowBorder: {
    borderBottomWidth: 1,
    borderBottomColor: BORDER_COLOR,
  },
  cell: {
    flex: 1,
    paddingVertical: 12,
    paddingHorizontal: 24,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: BG_COLOR,
  },
  leftCell: {
    // nothing extra, but kept for clarity
  },
  rightCell: {
    // nothing extra, but kept for clarity
  },
  borderRight: {
    borderRightWidth: 1,
    borderRightColor: BORDER_COLOR,
  },
  headerText: {
    color: '#c9b65b',
    fontWeight: 'bold',
    fontSize: 14,
    textAlign: 'center',
  },
  dataText: {
    color: '#c9b65b',
    fontSize: 14,
    fontWeight: '500',
    textAlign: 'center',
  },
});

export default InvitationRuleTable;
